var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),_c('sidebar-fixed-toggle-button'),_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":_vm.$t('sidebar.shortTitle'),"title":_vm.$t('sidebar.title')}},[_c('template',{slot:"links"},[(_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('nav.dashboard'),
        icon: 'tim-icons icon-chart-pie-36',
        path: '/admin/dashboard'
      }}}):_vm._e(),(_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('nav.clients'),
        icon: 'tim-icons icon-bank',
        path: '/admin/clients'
      }}}):_vm._e(),(_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('nav.payments'),
        icon: 'tim-icons icon-coins',
        path: '/admin/payments'
      }}}):_vm._e(),(!_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('nav.pos'),
        icon: 'tim-icons icon-cart',
        path: '/fiscal/pos'
      }}}):_vm._e(),(!_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('nav.locations'),
        icon: 'tim-icons icon-square-pin',
        path: '/fiscal/locations'
      }}}):_vm._e(),(!_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('nav.esirs'),
        icon: 'tim-icons icon-tv-2',
        path: '/fiscal/esirs'
      }}}):_vm._e(),(_vm.isAdmin && !_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('nav.users'),
        icon: 'tim-icons icon-single-02',
        path: '/fiscal/users'
      }}}):_vm._e(),(!_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('nav.invoices'),
        icon: 'tim-icons icon-paper',
        path: '/fiscal/invoices'
      }}}):_vm._e(),(!_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('nav.reports'),
        icon: 'tim-icons icon-chart-bar-32',
        path: '/fiscal/reports'
      }}}):_vm._e(),(_vm.isAdmin && !_vm.isSuperAdmin)?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('nav.apiTokens'),
        icon: 'tim-icons icon-key-25',
        path: '/fiscal/api-tokens'
      }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('nav.logout'),
        icon: 'tim-icons icon-button-power'
      }},nativeOn:{"click":function($event){return _vm.logout.apply(null, arguments)}}})],1)],2),_c('sidebar-share',{attrs:{"background-color":_vm.sidebarBackground},on:{"update:backgroundColor":function($event){_vm.sidebarBackground=$event},"update:background-color":function($event){_vm.sidebarBackground=$event}}}),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar'),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }